import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "row q-col-gutter-lg" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.posts, (post) => {
      return (_openBlock(), _createElementBlock("div", {
        key: post.id,
        class: "col-xs-12 col-sm-6 col-md-4 col-lg-3"
      }, [
        _renderSlot(_ctx.$slots, "default", _normalizeProps(_guardReactiveProps(post)))
      ]))
    }), 128))
  ], 512)), [
    [_vShow, _ctx.posts.length]
  ])
}